module.exports = __webpack_public_path__ + "fonts/seguibli.38b35433.ttf";